class CollectionsViewer extends BaseView {

    public mainContainer: HTMLElement;

	public frag: DocumentFragment;

	private navDrawer: NavDrawer;

	private navControlBtnIcon:  HTMLElement;

	public navControl: HTMLElement;

	public navControlBtn: HTMLElement;

	public navControlH1: HTMLElement;

	public cHeader: HTMLElement;

	public infoPanelControl:  HTMLElement;

	/**
	 * Current nav panel id
	 * @private
	 */
	private id: string | number;

	/**
	 * Are we coming from a history navigation?
	 * (On creation it will always be true since its the first 'navigation')
	 * @private
	 */
	private historic: boolean = true;

	/**
	 * ID being requested from history
	 * @private
	 */
	private historyId: number | string;

	/**
	 *
	 * @private
	 */
	private panel: CollectionPanel;


	/**
	 *
	 * @param container
	 * @param id
	 * @param type
	 */
	constructor(container: HTMLElement, id?: number | string, type?: number) {
		super();

		this.mainContainer = container;
		this.historyId = id ?? null;

		if (typeof id === "string" && type === null) {
			type = CollectionType.GuestAccess;
		}

		this.view(type);
		this.setUpEvents();
	}

	/**
	 *
	 */
	setUpEvents(): void {
		EVENT.attach(this.navControlBtn, 'click', () => this.toggleDrawer.call(this));

		iwKeys.attach("[",
			{fn: this.toggleDrawer.bind(this),
				name: iwi18n.gettext('collections', 'Toggle nav drawer'),
				description: iwi18n.gettext('collections', 'Toggle nav drawer')});

		EVENT.attach(document, 'CollectionPanel', (e: CustomEvent) => {
			let cID = e.detail.id;
			if (cID === null) {
				iwCore.addClassName(this.mainContainer, 'c-collections--overview');
				iwCore.removeClassName(this.mainContainer, 'c-collections--results');
			} else {
				iwCore.removeClassName(this.mainContainer, 'c-collections--overview');
				iwCore.addClassName(this.mainContainer, 'c-collections--results');
			}
		});

		EVENT.attach(window, 'popstate', (e: PopStateEvent) => {
			if (e.state && typeof e.state.type !== undefined) {
				this.historic = true;
				this.historyId = e.state.id ?? null;
				let item = this.navDrawer.getItemById(e.state.type);
				this.navDrawer.changeItem(item);
			}
		});

		EVENT.attach(window, 'windowResized', (e: Event) => {
			//when resizing we need to close or open nav as per screen appropriate size
			iwCore.addClassName(document.body, 'c-noAnim');
			this.setNavClass();
		});
	}

	/**
	 *
	 */
	view(type?: number): void {
		this.navControl = iwUI.createEl('div', {class: 'c-nav-control'});
		this.navControlBtn = iwUI.createEl('button', {class: 'c-nav-control-btn', 'aria-label':iwi18n.gettext('collections', 'Open %1 navigation', iw.collectionsPluralName)});
		this.navControlBtnIcon = iwUI.createEl('span', {class: 'icon-css icon-css--chevrons', 'aria-hidden':'true'});
		this.navControlH1 = iwUI.createEl('h1', {class: 'c-nav-control-title'});
		this.frag = document.createDocumentFragment();
		this.cHeader = iwUI.createEl('div');
		this.mainContainer.className = 'c-collections' + (this.historyId ? '' : ' c-collections--overview');

		if (type === CollectionType.GuestAccess) {
			iwCore.addClassName(this.mainContainer, 'c-collections--public');
		}

		this.navDrawer = new NavDrawer([
			{id: CollectionType.MineOnly, title: iwi18n.gettext('collections', 'My %1', iw.collectionsPluralName), cssClass:'c-nav-item c-nav-item--mine'},
			{id: CollectionType.All, title: iwi18n.gettext('collections', 'All %1', iw.collectionsPluralName), cssClass:'c-nav-item c-nav-item--all'},
			{id: CollectionType.Smart, title: iwi18n.gettext('collections', 'All smart %1', iw.collectionsPluralName), cssClass:'c-nav-item c-nav-item--smart'},
			{id: CollectionType.SharedWithMe, title: iwi18n.gettext('collections', 'Shared with me'), cssClass:'c-nav-item c-nav-item--shared'},
			{id: CollectionType.Public, title: iwi18n.gettext('collections', 'Public'), cssClass:'hide'},
			{id: CollectionType.GuestAccess, title: '', cssClass: 'hide',  attrs: [{name: 'aria-hidden',value: true}, {name: 'aria-label',value: iwi18n.gettext('collections', 'Guest access')}]}
		], this.loadPanel.bind(this), 'c-nav', 'collectionViewNav', type);

		this.navControlH1.textContent = iwCore.capitaliseFirst(iw.collectionsPluralName);

		this.navControl.appendChild(this.navControlH1);
		this.navControlBtn.appendChild(this.navControlBtnIcon);
		this.navControl.appendChild(this.navControlBtn);

		this.mainContainer.prepend(this.navControl);
		this.mainContainer.prepend(this.navDrawer.mainContainer);

		this.panel.pageHeight();
	}

	/**
	 *
	 * @param navItem
	 */
	public loadPanel(navItem: NavDrawerItem) {
		iwCore.addClassName(document.body, 'init-load');

		this.id = navItem.id;

		let sort = null;
		if (this.panel) {
			// close out our events
			sort = this.panel.sort;
			this.panel.openCollections(false);
		}

		switch (this.id) {
			case CollectionType.All:
				this.panel = new AllCollections(navItem.title, this.historyId, sort);
				break;
			case CollectionType.Favourites:
				this.panel = new Favourites(navItem.title);
				break;
			case CollectionType.MineOnly:
				this.panel = new MyCollections(navItem.title, this.historyId, sort);
				break;
			case CollectionType.SharedWithMe:
				this.panel = new SharedWithMe(navItem.title, this.historyId, sort);
				break;
			case CollectionType.Public:
				this.panel = new Public(navItem.title, this.historyId, sort);
				break;
			case CollectionType.GuestAccess:
				this.panel = new GuestAccess('', this.historyId, sort);
				break;
			case CollectionType.Smart:
				this.panel = new Smart(navItem.title, this.historyId, sort);
				break;
		}

		iwCore.clearElement(this.frag);
		let cPanel = document.getElementsByClassName('c-panel')[0];

		if (cPanel) {
			cPanel.remove();
		}

		//close nav if on mobile after menu item selection
		this.setNavClass();

		this.frag.appendChild(this.panel.mainContainer);
		this.mainContainer.appendChild(this.frag);

		this.panel.addNavigation(this.historyId, this.historic);
		this.panel.pageHeight();

		this.historyId = null;
		this.historic = false;
	}

	/**
	 * set the nav open by default for desktop view
	 * set the nav closed by default for anything but desktop view
	 * @public
	 */
	public setNavClass() {
		let breakPoint = iwCore.browser.breakPoint(window.innerWidth, window.innerWidth);

		//add closing classes for animation purposes
		if (breakPoint === 'desktop') {
			iwCore.addClassName(this.mainContainer, 'cNav-isActive');
			iwCore.removeClassName(this.mainContainer, 'cNav-isClosed');
		} else {
			iwCore.removeClassName(this.mainContainer, 'cNav-isActive');
			iwCore.addClassName(this.mainContainer, 'cNav-isClosed');

			requestAnimationFrame(function(this: CollectionsViewer) {
				this.panel.pageHeight();
			}.bind(this));
		}
		//prevent weird layout issues if the user tries to resize with the search open on mobile
		iwCore.removeClassName(this.panel.mainContainer, 'cSearch-isActive');

		//clear class that prevents animation on resize
		requestAnimationFrame(function() {
			iwCore.removeClassName(document.body, 'c-noAnim');
		});
	}

	/**
	 * Open nav drawer
	 * @private
	 */
	private toggleDrawer() {
		if (this.navDrawer) {
			iwCore.toggleClassName(this.mainContainer, 'cNav-isActive');
			iwCore.toggleClassName(this.mainContainer, 'cNav-isClosed');
		}
	}

	/**
	 * Get all ids
	 * @param collectionID
	 * @param smartID
	 * @param ids
	 * @param type
	 * @param cbFn
	 * @param errorMsg
	 * @private
	 */
	public static getCollectionIds(collectionID: number|string, smartID: number|null, ids: Array<number>|null, type: BatchTypes, cbFn: (e: any) => void, errorMsg: string) {
		iwCore.ajax({
			type: 'GET',
			url: '/collections/getcollectionids',
			data: {
				collectionID: collectionID,
				smartID: smartID,
				ids: ids ? ids.join(',') : null,
				type: type
			},
			beforeSend: () => iwCore.loading(true),
			complete: () => iwCore.loading(false),
			success: (e: any) => cbFn(e),
			error: () => {
				iwNotifications.error(errorMsg, iwi18n.gettext('projects', 'Error'));
			}
		});
	}

	/**
	 * Get collection ctx menu params
	 * @param collection
	 * @param isParent - displays the "view" option
	 */
	public static getCollectionCtxParams(collection: any, isParent: boolean = false): any {
		let hasWorkflow = false,
			params: any = {};

		// list functionality
		if (collection.mediaType) {
			if (collection.mediaType === 'Video') {
				hasWorkflow = collection.hasVideoWorkflow;
			} else if (collection.mediaType === 'Audio') {
				hasWorkflow = collection.hasAudioWorkflow;
			}
		} else if (collection.mediaTypes) {
			// individual collection panel
			collection.mediaTypes.forEach((item: any) => {
				switch(item) {
					case 'Video':
						hasWorkflow = collection.hasVideoWorkflow;
						break;
					case 'Audio':
						hasWorkflow = collection.hasAudioWorkflow;
						break;
				}
			});
		}

		params.showdownload = hasWorkflow && collection.showOrder;
		params.showdownloadfor = hasWorkflow && collection.showOrderFor;

		params.title = iwCore.capitaliseFirst(iwi18n.gettext('collections', '%1 options', iw.collectionsName));
		params.collectionID = collection.id.toString();
		params.id = collection.id.toString();
		params.collection_id = collection.id.toString();
		params.usercanedit = !!collection.canEdit;
		params.collectionname = collection.title;
		params.description = collection.description;
		params.creationDate = collection.rawCreationDate;
		params.modifiedDate = collection.rawModifiedDate;
		params.basketsenabled = !!iw.basketsEnabled && collection.numHits > 0;
		params.isparent = isParent;
		params.ispublic = collection.isPublic;
		params.collection_url = window.location.origin + '/collections/' + collection.id;
		params.collection_public_url = collection.publicUrl
		params.collectionhits = collection.numHits;
		params.canrunworkflowonall = !collection.smartId && !iw.isGuest && !!collection.canEdit && collection.numHits > 0;
		params.collectionName = collection.title;
		params.type = 'collection';
		params.save = '1';
		params.canShare = collection.publicUrl && !iw.isGuest && !collection.isAnonLink;
		params.isEmpty = collection.numHits === 0;

		if (collection.smartId) {
			params.smartid = collection.smartId;
		}

		// add enquiry related params
		EnquiryData.getMenuData(params);

		// return the merged object
		return params;
	}
}